import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';

import { AuthService } from '../../services/auth.service';
import { FlowInstanceService } from '../../flow/services/flow-instance.service';
import { Observable } from 'rxjs';

// Checks if user has permission to instantiate a flow
@Injectable()
export class InstantiateFlowGuardService  {

  constructor(public authService: AuthService,
              public flowService: FlowInstanceService,
              public router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): boolean | Observable<boolean> {
    if (this.authService.canStartFlow(route.params.id)) {
      return true;
    } else {
      this.router.navigate(['/home/unauthorized']);
      return false;
    }          
    // return this.flowService.getLatestPublishedTemplate(route.params.id).map(template => {
    //   if (template.isPublic) return true;

    //   if (this.authService.hasFlowPermission(route.params.id)) {
    //     return true;
    //   } else {
    //     this.router.navigate(['/home/unauthorized']);
    //     return false;
    //   }      
    // });
  }

}
